import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';
import { FormGroup } from '@angular/forms';
import { debounceTime, map, Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DocumentExchangeCategory } from 'src/app/classes/document-exchange';
import { DocumentExchangeService } from 'src/app/services/document-exchange.service';


@Component({
	selector: 'app-document-exchange-category-editor',
	templateUrl: './document-exchange-category-editor.component.html',
	styleUrls: [ './editor.component.css' ]
})
export class DocumentExchangeCategoryEditorComponent implements OnInit, AfterViewInit, OnDestroy {


	private _group = new DocumentExchangeCategory();
	@Input() set group( val: DocumentExchangeCategory ) {
		this._group = val;
		this.updateValueForm();
	}
	get group() { return this._group; }

	formG1 = new FormGroup( {} );
	myInputs: { [key: string]: DataInput } = {};

	@Output() done = new EventEmitter<DocumentExchangeCategory>();

	bInProgress = false;
	subscriptions = new Subscription();
	bIsDuplicate = false;
	bSaving = false;
	bError = false;


	constructor(
		private documentExchangeService: DocumentExchangeService,
		private matSnackBar: MatSnackBar
	) {}


	ngOnInit() {

		const di1 = new DataInput();
		di1.id = "name";
		di1.label = "Name";
		di1.type = "text";
		di1.required = true;
		di1.maxlength = 50;
		this.myInputs[ "name" ] = di1;

		const di2 = new DataInput();
		di2.id = "description";
		di2.label = "Beschreibung";
		di2.type = "text";
		di2.required = true;
		di2.maxlength = 50;
		this.myInputs[ "description" ] = di2;

		const di3 = new DataInput();
		di3.id = "email";
		di3.label = "Erinnerungs-Mail";
		di3.type = "check";
		di3.required = true;
		this.myInputs[ "email" ] = di3;

	}


	ngAfterViewInit() {

		setTimeout( () => {

			this.updateValueForm();

			this.subscriptions.add(
				this.formG1.valueChanges.pipe(
					debounceTime( 400 ),
					map( values => {

						if( !this.formG1.valid ) return;
						if( !this._group.id ) return;
						/*
						const newName = "" + this.formG1.get( "name" )?.value;
						this.bIsDuplicate = !this.documentExchangeService.isUniqueCalendarName( this._group.id, newName );
						if( this.bIsDuplicate ) return;
						*/

						this.save();

					})
				).subscribe()
			);

		}, 1 );

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}


	updateValueForm() {

		// the formgroup has to be initialized
		if( !this.formG1.get( 'name' ) ) return;

		this.formG1.reset();
		this.formG1.patchValue( {
			name: this._group.name,
			description: this._group.description,
			email: this._group.email
		} );

	}

	cancel() {
		this.done.emit( new DocumentExchangeCategory() );
	}

	reset() {
		this.updateValueForm();
	}

	save() {

		this.bSaving = true;

		const elementToSave = { ...this._group } as DocumentExchangeCategory;

		elementToSave.name = this.formG1.get( "name" )?.value || "";
		elementToSave.description = this.formG1.get( "description" )?.value || "";
		elementToSave.email = this.formG1.get( "email" )?.value || false;

		this.documentExchangeService.saveDocumentExchangeCategory( elementToSave ).subscribe( savedCategory => {

			this.bSaving = false;

			if( savedCategory && savedCategory.id ) {
				this.bError = false;
				this.matSnackBar.open( 'Erfolgreiche Speicherung', 'Speichern' );

				this._group.id = savedCategory.id;
				this._group.name = savedCategory.name;
				this._group.description = savedCategory.description;
				this._group.email = savedCategory.email;

				this.formG1.markAsPristine();

				this.done.emit();
			}
			else {
				this.bError = true;
			}

		});

	}


}
